export var CvsdkEventCueType = /*#__PURE__*/ function(CvsdkEventCueType) {
    CvsdkEventCueType["AdBreak"] = "cvsdk::ad-break";
    CvsdkEventCueType["Ad"] = "cvsdk::ad";
    CvsdkEventCueType["AdTracking"] = "cvsdk::ad-tracking";
    CvsdkEventCueType["Custom"] = "cvsdk::custom";
    return CvsdkEventCueType;
}({});

//# sourceMappingURL=event.enums.js.map